import { useIntl } from 'react-intl';

import type { SubmitError } from '../types';
import { possiblyTranslate } from '../utils';

export const useTranslateSubmitError = <Values extends {}>() => {
    const { formatMessage } = useIntl();

    const translate = (...[name, error, options]: SubmitError<Values>) => {
        const translatedError = possiblyTranslate(error, { formatMessage });
        return [name, translatedError, options] as const satisfies SubmitError<Values>;
    };

    return translate;
};
